import { NODE_ENV_ZOD } from "@connected-repo/zod-schemas/node_env";
import { z } from "zod";

const urlOrEmpty = z.preprocess(
	(val) => (val === "" ? undefined : val),
	z.url("API URL must be a valid URL").optional(),
);

const envSchemaZod = z.object({
	VITE_USER_NODE_ENV: NODE_ENV_ZOD,
	// Empty = same-origin: nginx (prod) or the Vite proxy (dev) forwards
	// /api/* and /super-admin/* to the backend.
	VITE_API_URL: urlOrEmpty,
});

export const env = envSchemaZod.parse(import.meta.env);
export const isDev = env.VITE_USER_NODE_ENV === "development";

/** Base origin for backend calls; empty string means "this origin". */
export const apiBase = env.VITE_API_URL ?? "";
